export default {

    background: "#e9eaee",
    backgroundSecondary: "#fbfbff",

    primary: "#0c6681",
    primaryDark: "#003c54",
    primaryLight: "#71cace",

    textOnPrimary: "#ffffff",
    textOnSecondary: "#dddddd",
    fundoPage: "#ffffff",
    fundoIconeHome: "#f8f8f7",
    fundoHomeEmpresa: "#0d6781",
    fundoVerde: "#95eb9d",
    fundoVermelho: "#ee8888",
    fundoAzul: "#5d9df1",

    buttonPrimary: "#003c54",
    buttonSecondary: "#0c6681",

    accent: "#212121",
    accentDark: "#000000",
    accentLight: "#484848",
    textOnAccent: "#ffffff",
    textRed: "#FF0000",

    textPrimaryDark: "#000000DD", // 87%
    textSecondaryDark: "#00000089", // 54%
    textDisabledDark: "#00000060", // 38%
    textHintDark: "#00000060", // 38%
    dividerDark: "#0000001F", // 12%

    textPrimaryLight: "#ffffff", // 100%
    textSecondaryLight: "#ffffffB2", // 70%
    textDisabledLight: "#ffffff7F", // 50%
    textHintLight: "#ffffff7F", // 50%
    dividerLight: "#ffffff3d", // 24%

    transparent: "#00000000",
};


// WEBPACK FOOTER //
// ./src/utils/Colors.js